import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

const partnershipsApi = {
    getDrinksItems: async () => {
        const url = `api/partnerships/v1/drinks/items`;
        return mmFetchWithResponse(url);
    },
    updateDrinksItem: async (id, sendParams) => {
        const url = `api/partnerships/v1/drinks/items/${id}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
    },
    getNewDrinksItems: async () => {
        const url = `api/partnerships/v1/drinks/items`;
        return mmFetchWithResponse(url, { method: 'POST' });
    },
    cancelImportedShipment: async (shipmentID) => {
        const url = 'api/partnerships/v1/import/orders/cancel';
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ shipmentID }),
        });
    },
    confirmOrderUpload: async (key) => {
        const url = 'api/partnerships/v1/import/confirm';
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ key }),
        });
    },
    getImportedOrders: async () => {
        const url = 'api/partnerships/v1/import/orders';
        return mmFetchWithResponse(url);
    },
    getOrderImportSources: async () => {
        const url = 'api/partnerships/v1/import/sources';
        return mmFetchWithResponse(url);
    },
    updateOrderImportSource: async (id, sendParams) => {
        const url = `api/partnerships/v1/import/sources/${id}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
    },
    createImportedOrderSource: async (sendParams) => {
        const url = 'api/partnerships/v1/import/sources';
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(sendParams),
        });
    },
    uploadOrders: async (data) => {
        const formData = new FormData();
        formData.append('itemFile', data.file);
        formData.append('source', data.source);

        const url = 'api/partnerships/v1/import';
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
    },
    uploadSubscriptions: async (data) => {
        const formData = new FormData();
        formData.append('itemFile', data.file);
        formData.append('source', data.source);

        const url = `api/partnerships/v1/fam/subscriptions/import?source=${data.source}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
    },
    confirmSubscriptionsUpload: async (key, source) => {
        const url = `api/partnerships/v1/fam/subscriptions/import/confirm?source=${source}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ key }),
        });
    },
    getSources: async (sourceName = '') => {
        const url = `api/partnerships/v1/fam/sources?sourceName=${sourceName}`;
        return mmFetchWithResponse(url);
    },
    getSubscriptionOptions: async (source) => {
        const url = `api/partnerships/v1/fam/subscription/options?source=${source}`;
        return mmFetchWithResponse(url);
    },
    getDeliverySchedulePreview: async (deliveryDay, numOrders, frequency, zipCode, id) => {
        let url = `api/partnerships/v1/fam/subscription/preview?day=${deliveryDay}&zip=${zipCode}&numOrders=${numOrders}&frequency=${frequency}`;
        if (id) {
            url += `&id=${id}`;
        }
        return mmFetchWithResponse(url);
    },
    simulateSubscriptionOrders: async (source, sendParams) => {
        const url = `api/partnerships/v1/fam/subscription/simulate?source=${source}`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(sendParams),
        });
        return response;
    },
    createSubscription: async (source, sendParams) => {
        const url = `api/partnerships/v1/fam/subscription?source=${source}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(sendParams),
        });
    },
    editSubscription: async (subID, sendParams, source) => {
        const url = `api/partnerships/v1/fam/subscription/${subID}?source=${source}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
    },
    cancelOrder: async (source, subID, orderID) => {
        const url = `api/partnerships/v1/fam/subscription/${subID}/orders/${orderID}/cancel?source=${source}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
        });
    },
    cancelSubscription: async (source, subID) => {
        const url = `api/partnerships/v1/fam/subscription/${subID}/cancel?source=${source}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
        });
    },
    getPartnershipOrders: async (source, page, search, filters, orderBy) => {
        let url = `api/partnerships/v1/fam/orders?source=${source}&page=${page}&pageSize=20&order=${orderBy}`;
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        Object.keys(filters).forEach((key) => {
            const value = filters[key];
            url += `&${key}=${encodeURIComponent(value)}`;
        });
        return mmFetchWithResponse(url);
    },
    getShipmentDetailsForOrder: async (orderID) => {
        const url = `api/partnerships/v1/fam/orders/${orderID}`;
        return mmFetchWithResponse(url);
    },
    addToSkuExclusionList: async (listID, externalSku, source) => {
        const url = `api/partnerships/v1/fam/lists/${listID}/sku-exclusion/${externalSku}?source=${source}`;
        return mmFetchWithResponse(url, { method: 'POST' });
    },
    removeFromSkuExclusionList: async (listID, externalSku, source) => {
        const url = `api/partnerships/v1/fam/lists/${listID}/sku-exclusion/${externalSku}?source=${source}`;
        return mmFetchWithResponse(url, { method: 'DELETE' });
    },
    getSkuExclusionList: async (listID, source) => {
        const url = `api/partnerships/v1/fam/lists/${listID}/sku-exclusion?source=${source}`;
        return mmFetchWithResponse(url);
    },
    createCuratedList: async (sendParams) => {
        const url = `api/partnerships/v1/fam/curatedList`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(sendParams),
        });
    },
    getCuratedListsForPartner: async (source, listID, page, searchTerm, active) => {
        let url = `api/partnerships/v1/fam/lists?source=${source}&listID=${listID}&page=${page}&pageSize=20&active=${active}`;
        if (searchTerm) {
            url += `&name=${searchTerm}`;
        }
        return mmFetchWithResponse(url);
    },
    getSupplementalItemsForPartner: async (source) => {
        const url = `api/partnerships/v1/fam/subscription/supplemental-items?source=${source}`;
        return mmFetchWithResponse(url);
    },
    getSubscriptionsForPartner: async (source, page, searchTerm, subID = '', filters = {}, exportToCsv = false) => {
        let url = `api/partnerships/v1/fam/subscription?source=${source}`;

        if (exportToCsv) {
            url += '&export=true';
        } else {
            url += `&page=${page}&pageSize=20`;
        }
        if (subID) {
            url += `&id=${subID}`;
        }
        if (searchTerm) {
            url += `&name=${searchTerm}`;
        }

        Object.keys(filters).forEach((key) => {
            const value = filters[key];
            url += `&${key}=${encodeURIComponent(value)}`;
        });

        if (exportToCsv) {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = 'subscriptions.csv';
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } else {
            return mmFetchWithResponse(url);
        }
    },
    getSubscriptionOrders: async (source, subID) => {
        const url = `api/partnerships/v1/fam/subscription/${subID}/orders?source=${source}`;
        return mmFetchWithResponse(url);
    },
    getEmptyItemsForPartner: async (source) => {
        const url = `api/partnerships/v1/fam/lists/empty?source=${source}`;
        return mmFetchWithResponse(url);
    },
    getCuratedListsForPartnerCSV: async (source) => {
        const url = `api/partnerships/v1/fam/lists?source=${source}&csv=true`;
        const filename = `lists.csv`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[getItemsWithTaxonomyForWeekYearCSV] error', e.toString());
        }
    },
    getValidDeliveryDaysForZip: async (zip) => {
        const url = `api/partnerships/v1/fam/subscription/validDays?zip=${zip}`;
        return mmFetchWithResponse(url);
    },
    addSlotToPartnershipList: async (
        listID,
        slotNumber,
        required,
        packGroupItems,
        taxonomyIDs,
        taxonomyLevel,
        taxonomyOrderBy,
    ) => {
        const url = `api/partnerships/v1/fam/lists/${listID}/slot/${slotNumber}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ required, packGroupItems, taxonomyIDs, taxonomyLevel, taxonomyOrderBy }),
        });
    },
    removeSlotFromPartnershipList: async (listID, slotNumber) => {
        const url = `api/partnerships/v1/fam/lists/${listID}/slot/${slotNumber}`;
        return mmFetchWithResponse(url, { method: 'DELETE' });
    },
    getFAQs: async () => {
        const url = `api/partnerships/v1/fam/faqs`;
        return mmFetchWithResponse(url);
    },
    getDeliveryScheduleCSV: async () => {
        const url = `api/partnerships/v1/fam/deliverySchedule`;
        const filename = 'deliverySchedule.csv';
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[getDeliveryScheduleCSV] error', e.toString());
        }
    },
    getItemsWithTaxonomy: async (source) => {
        const url = `api/partnerships/v1/fam/taxonomyItems?source=${source}`;
        return mmFetchWithResponse(url);
    },
    getItemsWithTaxonomyCSV: async (source) => {
        const url = `api/partnerships/v1/fam/taxonomyItems?source=${source}&csv=true`;
        const filename = `inventory.csv`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[getItemsWithTaxonomyForWeekYearCSV] error', e.toString());
        }
    },
    duplicateList: async (listID, name) => {
        const url = `api/partnerships/v1/fam/lists/${listID}/duplicate`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ name }),
        });
    },
    replaceListItems: async (replacementExtSku, itemsToReplace) => {
        const url = `api/partnerships/v1/fam/lists/item/replace`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({
                replacementSku: replacementExtSku,
                itemsToReplace,
            }),
        });
    },
    getImports: async (source) => {
        const url = `api/partnerships/v1/fam/imports?source=${source}`;
        return mmFetchWithResponse(url);
    },
    getImportByID: async (source, id) => {
        const url = `api/partnerships/v1/fam/imports/${id}?source=${source}`;
        return mmFetchWithResponse(url);
    },
    retryImportedRows: async (source, rowIDs, forceCreate) => {
        const url = `api/partnerships/v1/fam/imports/retry?source=${source}`;
        return mmFetchWithResponse(url, { method: 'POST', body: JSON.stringify({ rowIDs, forceCreate }) });
    },
    updateImportedRow: async (rowID, source, sendParams) => {
        const url = `api/partnerships/v1/fam/imports/row/${rowID}?source=${source}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
    },
    updateScheduledOrder: async (source, scheduledOrderID, sendParams) => {
        const url = `api/partnerships/v1/fam/subscription/orders/${scheduledOrderID}?source=${source}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
    },
    retryScheduledOrders: async (source, scheduledOrderIDs, forceCreate) => {
        const url = `api/partnerships/v1/fam/subscription/orders/retry?source=${source}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ scheduledOrderIDs, forceCreate }),
        });
    },
    getFailedSubscriptionOrders: async (source) => {
        const url = `api/partnerships/v1/fam/subscription/failedOrders?source=${source}`;
        return mmFetchWithResponse(url);
    },
    addSupplementalItemOption: async (source, sendParams) => {
        const url = `api/partnerships/v1/fam/subscription/supplemental-items/option?source=${source}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(sendParams),
        });
    },
    removeSupplementalItemOption: async (source, optionID) => {
        const url = `api/partnerships/v1/fam/subscription/supplemental-items/option/${optionID}?source=${source}`;
        return mmFetchWithResponse(url, { method: 'DELETE' });
    },
    addSupplementalItemSchedule: async (source, sendParams) => {
        const url = `api/partnerships/v1/fam/subscription/supplemental-items/schedule?source=${source}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(sendParams),
        });
    },
    removeSupplementalItemSchedule: async (source, scheduleID) => {
        const url = `api/partnerships/v1/fam/subscription/supplemental-items/schedule/${scheduleID}?source=${source}`;
        return mmFetchWithResponse(url, { method: 'DELETE' });
    },
};

export { partnershipsApi };
